import { types } from 'mobx-state-tree';

import {
    ConstructionTypeValues,
    RoofTypeValues,
    FireHydrantValues,
    FirehallValues,
    HeatingValues,
    FuelTypeValues,
    ElectricalWiringValues,
    PipingTypeValues,
    WaterTankValues,
    NumberOfStories,
    FinishedBasementValues,
    ElectricPanelValues,
    ElectricalAmpsValues,
    ExteriorFinishValues,
    GarageTypeValues,
    PoolTypeValues,
    YearRoofLastUpdatedValues,
    YearWiringLastUpdatedValues,
    YearPlumbingLastUpdatedValues, 
} from '../definitions/InsCommon';


export default types
    .model('Construction', {
        yearBuilt: types.string,
        yearRoofLastUpdated: types.optional(
            types.maybeNull(types.union(types.number, types.string)),
            YearRoofLastUpdatedValues.NEVER,
        ),
        exteriorFinish: types.maybeNull(types.enumeration(
            Object.values(ExteriorFinishValues),
        )),
        constructionType: types.maybeNull(types.enumeration(
            Object.values(ConstructionTypeValues),
        )),
        numberOfBathrooms: types.maybe(types.number),
        roofType: types.maybe(types.enumeration(
            Object.values(RoofTypeValues),
        )),
        estimatedReplacementCost: types.number,
        fireHydrant: types.maybe(types.enumeration(
            Object.values(FireHydrantValues),
        )),
        firehall: types.maybe(types.enumeration(
            Object.values(FirehallValues),
        )),
        squareFootage: types.number,
        heating: types.maybe(types.enumeration(
            Object.values(HeatingValues),
        )),
        // Fuel type is null if heating is not 'central'
        fuelType: types.maybeNull(
            types.enumeration(
                Object.values(FuelTypeValues),
            ),
        ),
        numberOfStories: types.union(
            types.maybeNull(types.enumeration(NumberOfStories)),
        ),
        finishedBasement: types.maybeNull(
            types.enumeration(Object.values(FinishedBasementValues)),
        ),
        electricalWiring: types.maybe(types.enumeration(
            Object.values(ElectricalWiringValues),
        )),
        electricPanelType: types.maybe(types.enumeration(
            Object.values(ElectricPanelValues),
        )),
        electricalAmps: types.maybe(types.enumeration(
            Object.values(ElectricalAmpsValues),
        )),
        pipingType: types.maybeNull(
            types.enumeration(Object.values(PipingTypeValues)),
        ),
        waterTankStyle: types.maybe(types.enumeration(
            Object.values(WaterTankValues),
        )),
        garageType: types.maybeNull(types.enumeration(
            Object.values(GarageTypeValues),
        )),
        poolType: types.maybeNull(types.enumeration(
            Object.values(PoolTypeValues),
        )),
        yearWiringLastUpdated: types.optional(
            types.maybeNull(types.union(types.number, types.string)),
            YearWiringLastUpdatedValues.NEVER,
        ),
        yearPlumbingLastUpdated: types.optional(
            types.maybeNull(types.union(types.number, types.string)),
            YearPlumbingLastUpdatedValues.NEVER,
        ),
    })
    .views(self => ({
        get isValid() {
            return self.estimatedReplacementCost > 0
                && (self.fuelType !== null || self.heating === HeatingValues.CENTRAL)
                && [
                    self.yearRoofLastUpdated,
                    self.exteriorFinish,
                    self.constructionType,
                    self.garageType,
                    self.poolType,
                    self.yearPlumbingLastUpdated,
                    self.yearWiringLastUpdated,
                ].every(field => field !== null);
        },
    }));
